var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.randomGasesSeed)?_c('lab-task',[_c('lab-sim',{attrs:{"random-gases-seed":_vm.randomGasesSeed,"lab-name":"grahams-law"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }